/**
 * Статический asset из project.json (копия libs/.../python-webworker.js → dist/assets).
 * document.baseURI — учёт base href; без import.meta.url (нет file:// в бандле).
 */
export function createSkyproPythonWorker(): Worker {
  return new Worker(new URL('assets/python-webworker.js', document.baseURI));
}
